import Comment from './comment.js';
import textAreaListener from '../../services/textAreaListener';
import { swapSrcPaths } from '../../helpers/index.js';
import Lazyloading from '../../services/lazy-loading/lazyLoading.js';

class Comments extends Comment {
	constructor(root, isAuthorized) {
		super();
		this.root = root;
		this.isAuthorized = isAuthorized;
		this.errorMessage = '';
		this.timeout;
		this.reCaptchaKey = document.querySelector('[data-site]').dataset.site;
		this.hashPath = window.location.hash;
		this.list = this.root.querySelector('.comments__list');
		this.buttonLoadMore = this.root.querySelector('.button-load');
		this.stateText = '';
		if (this.buttonLoadMore) {
			this.icon = this.buttonLoadMore.querySelector('.button-load__icon');
			this.text = this.buttonLoadMore.querySelector('.button-load__text');
		}

		// Проверяем есть ли в пути хеш на коммент
		if (this.hashPath) {
			this.scrollToHashComment(this.hashPath);
		}

		if (this.isAuthorized === 'false') {
			const errorMessageElement = this.root.querySelector('.comments__form-error');
			this.errorMessage = errorMessageElement.innerHTML;
			this.disabledBtns();
		} else {
			const form = this.root.querySelector('.comments__form');
			// Увеличение размера textarea в зависимости от набранного текста
			textAreaListener(form);
			form.addEventListener('submit', this.submitForm.bind(this));
			this.createNewCommentInstance();
		}

		this.root.querySelectorAll('script').forEach((script) => {
			if (script.hasAttribute('data-src')) {
				swapSrcPaths(script);
			}
		});

		if (this.buttonLoadMore) {
			this.loadMoreCommets();
		}

		document.addEventListener('DOMContentLoaded', this.captchaObserverScript.bind(this));
	}

	captchaObserverScript() {
		if ('IntersectionObserver' in window) {
			const callback = (entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						let script = entry.target.querySelector('script');
						if (script) swapSrcPaths(script);
						capchaObserver.unobserve(this.root);
					}
				});
			};
			const options = {
				root: null,
				rootMargin: '50px 0px 0px',
				threshold: 0.1,
			};

			const capchaObserver = new IntersectionObserver(callback, options);
			capchaObserver.observe(this.root);
		} else {
			// Possibly fall back to event handlers here
		}
	}

	// Скролим к комменту с хешом из location url, если коммент является сабкомментом и скрыт в details, открываем его
	scrollToHashComment(hash) {
		const commentId = +/\d+/.exec(hash);
		const commentToView = this.root.querySelector(`[data-id="${commentId}"]`);
		if (commentToView) {
			const detailsParent = commentToView.closest('details');
			if (detailsParent) {
				detailsParent.open = true;
			}
			window.addEventListener('DOMContentLoaded', function () {
				this.setTimeout(() => {
					commentToView.scrollIntoView({
						block: 'center',
						behavior: 'auto',
					});
				}, 42);
			});
		}
	}

	createNewCommentInstance() {
		const commentList = this.root.querySelectorAll('.comment');
		if (commentList.length) {
			commentList.forEach((comment) => {
				new Comment(comment);
			});
		}
	}

	disabledBtns() {
		const disabledBtns = this.root.querySelectorAll('textarea, .comment button');
		disabledBtns.forEach((element) => {
			element.classList.add('disabled');
			element.addEventListener('click', this.showWarningMessage.bind(this));
		});
	}

	showWarningMessage(e) {
		e.preventDefault();
		const target = e.target;
		const parent = target.parentElement;
		const errorMessagePopupList = this.root.querySelectorAll('.show-message');
		if (errorMessagePopupList.length) {
			errorMessagePopupList.forEach((popup) => {
				clearTimeout(this.timeout);
				const parent = popup.parentElement;
				this.removeErrorMessagePopup(parent);
			});
		}
		this.renderErrorPopup(parent, this.errorMessage);
	}

	removeErrorMessagePopup(selector) {
		const popup = selector.querySelector('.show-message');
		popup.remove();
	}

	loadMoreCommets() {
		this.buttonLoadMore.addEventListener('click', (event) => {
			event.preventDefault();
			this.loadingButtonSetState();
			fetch(this.buttonLoadMore.dataset.link, {
				method: 'GET',
			})
				.then((response) => {
					return response.json();
				})
				.then((data) => {
					if (data?.message) {
						throw new Error(data?.message);
					}

					if (data?.html) {
						this.list.innerHTML += data?.html;
					}

					if (data?.link !== null) {
						this.buttonLoadMore?.setAttribute('data-link', data.link);
					} else {
						this.buttonLoadMore?.remove();
					}

					this.createNewCommentInstance();
					new Lazyloading('img[loading=lazy]').init();
				})
				.catch((error) => console.error(error))
				.finally(() => this.loadingButtonSetState(false));
		});
	}

	loadingButtonSetState(loading = true) {
		this.icon?.classList.toggle('visually-hidden');

		if (this.icon && this.text) {
			if (loading) {
				this.buttonLoadMore?.setAttribute('disabled', 'true');
				this.stateText = this.text.innerHTML;
				this.text.innerHTML = 'Загрузка...';
			} else {
				this.buttonLoadMore?.removeAttribute('disabled');
				this.text.innerHTML = this.stateText;
			}
		}
	}
}

export default Comments;
